import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import ProductList from './Product-List.js';
import TaxonomyFilter from './Taxonomy-Filter.js';

import CategorieApplicative from './CategorieApplicative.js';

import getTaxonomyList from './getTaxonomyList.js';


// const API = 'http://generon.local/wp-json/wp/v2/product/';
// const API = 'https://staging.generon.it/wp-json/wp/v2/';

const API = '/wp-json/wp/v2/';
const API_V2 = '/wp-json/wp/v2/';

const API_ITEMS = "id,title,link,tecnologie_names,product_tag_names,brand_names,image,acf,codice_prodotto";

const API_SORT = "&orderby=title&order=asc";

// const QUERY_PER_PAGE = '?per_page=100';
// const QUERY_ITEMS = '?items=id,title,link&settore_merceologico=191';
// const QUERY_ITEMS = '?_embed&settore_merceologico=28';
let products = [];

let selectedUpdatedList = []; //selectedUpdatedList by tecnologie
let selectedProducts_Tags = [];
let selectedTecnologia;

let selectedBrand;


// https://gist.github.com/samikeijonen/7699b76c86fa2950d98ebee9e015b580

class App extends Component {

  constructor(props) {
    super(props);

    this.firstLoad = true;
    this.api = this.props.home_url + API;
    this.apiV2 = this.props.home_url + API_V2;

    this.lang = this.props.lang;

    let settoreMerceologicoQueryString = ((this.props.settoreMerceologico !== '') ? '&settore_merceologico=' + this.props.settoreMerceologico : '');
    let applicazioniQueryString = ((this.props.applicazioni !== '') ? '&applicazioni=' + this.props.applicazioni : '');
    let tecnologieQueryString = ((this.props.tecnologie !== '') ? '&tecnologie=' + this.props.tecnologie : '');

    let labels = JSON.parse(this.props.labels);

    this.SCEGLI_LA_TECNOLOGIA = labels['Scegli la tecnologia'];
    this.FILTRA_TRA = labels['Filtra tra'];
    this.TECNOLOGIA = labels['Tecnologia'];
    this.FORMATO = labels['Formato'];

    this.SCEGLI_IL_BRAND = labels['Scegli il brand'];
    this.NESSUN_RISULTATO = labels['Nessun risultato con i filtri applicati'];
    this.NESSUN_FILTRO_DISPONIBILE = labels['Nessun filtro disponibile'];








    this.state = {
      data: [],
      queryItems: '?items=' + API_ITEMS + settoreMerceologicoQueryString + applicazioniQueryString + tecnologieQueryString + '&lang=' + this.lang + '&per_page=50',
      queryTecnologie: '',
      isLoading: false,
      error: null,
      categorieApplicative: []

    };




    this.updateText1 = this.updateText1

    this.searchHandler = this.searchHandler.bind(this);
    this.onSearchFocus = this.onSearchFocus.bind(this);

    

  }

  updateText1 = (selectedTaxonomy) => {
    this.firstLoad = false;
    console.log("selectedTaxonomy", selectedTaxonomy);
    //console.log("selectedTaxonomy_taxonomy", selectedTaxonomy.taxonomy);

    // if ((selectedTaxonomy.checked) && (selectedTaxonomy.taxonomy == 'product_tag')) {
    //   selectedProducts_Tags.push(selectedTaxonomy.value);
    // } else {
    //   selectedProducts_Tags = selectedProducts_Tags.filter(item => { return item !== selectedTaxonomy.value });
    // }

    


    if (selectedTaxonomy.taxonomy == 'tecnologie') {
      selectedTecnologia = selectedTaxonomy.value;
      //selectedProducts_Tags = [];
    }


    if (selectedTaxonomy.taxonomy == 'brand') {
      selectedBrand = selectedTaxonomy.value;
      //selectedProducts_Tags = [];
    }

    if (selectedTaxonomy.taxonomy == 'product_tag') {
      selectedProducts_Tags = selectedTaxonomy.value;
      //selectedProducts_Tags = [];
    }



    console.log("selectedTecnologia", selectedTecnologia);
    console.log("selectedProducts_Tags", selectedProducts_Tags);
    console.log("selectedBrand", selectedBrand);

    // https://codepen.io/pjmtokyo/pen/ZGVjVV
    var updatedList = products;

    // filter by tecnologie first if any
    if ( (selectedTecnologia) && (selectedTecnologia.length > 0) ) {

      updatedList = updatedList.filter(item => {

        // loop for multiple values in api tecnologie
        for (var i = 0; i < item.tecnologie_names.length; i++) {
          if (item.tecnologie_names[i] == selectedTecnologia) { return true; }
        }

      });

      selectedUpdatedList = updatedList;
    } else {
      //if tecnologia is unchecked empty product tags filters
      //selectedUpdatedList = [];
    }

    // filter by tecnologie first if any



    // filter by brand first if any
    if ( (selectedBrand) && (selectedBrand.length > 0) ) {
      updatedList = updatedList.filter(item => {

        // loop for multiple values in api
        for (var i = 0; i < item.brand_names.length; i++) {
          if (item.brand_names[i] == selectedBrand) { return true; }
        }

      });

      selectedUpdatedList = updatedList;
    } else {
      //if brand is unchecked empty product tags filters
      //selectedUpdatedList = [];
    }
    // filter by brand first if any



    // filter by product_tag first if any
    if ( (selectedProducts_Tags) && (selectedProducts_Tags.length > 0) ) {
      updatedList = updatedList.filter(item => {

        // loop for multiple values in api
        for (var i = 0; i < item.product_tag_names.length; i++) {
          if (item.product_tag_names[i] == selectedProducts_Tags) { return true; }
        }

      });

      selectedUpdatedList = updatedList;
    } else {
      //if product_tag is unchecked empty product tags filters
      //selectedUpdatedList = [];
    }
    // filter by product_tag first if any







    // then filter by product_tag if any
    // if (selectedProducts_Tags.length > 0) {
    //   updatedList = updatedList.filter(item => {
    //     console.log("product_tag_names", item.product_tag_names);

    //     for (var i = 0; i < item.product_tag_names.length; i++) {

    //       for (var x = 0; x < selectedProducts_Tags.length; x++) {
    //         if (selectedProducts_Tags[x] == (item.product_tag_names[i])) { return true; }
    //       }


    //     }

    //   });
    // }




    sessionStorage.setItem('selectedTecnologia', selectedTecnologia);
    sessionStorage.setItem('selectedProducts_Tags', selectedProducts_Tags);
    // sessionStorage.setItem('updatedList', updatedList);


    // console.log("updatedList",updatedList);
    this.setState({ data: updatedList });

  }


  componentDidMount() {

    console.log("this.api", this.api);

    this.loadCategorieApplicative();

    if (this.props.applicazioni) {
      this.loadData();
    }

  }

  componentDidUpdate() {

  }




  loadData() {

    // get sessionStorage_products from sessionStorage if present otherwise load items
    const sessionStorage_products = sessionStorage.getItem('products_' + this.props.settoreMerceologico + '_' + this.props.applicazioni + '_' + this.props.tecnologie);
    if (sessionStorage_products !== null) {
      this.firstLoad = false;
      products = JSON.parse(sessionStorage_products);
      this.setState({ data: JSON.parse(sessionStorage_products), isLoading: false })
      return;
    }
    // get sessionStorage_products from sessionStorage if present otherwise load items


    console.log('loadData', this.api + 'product/' + this.state.queryItems + this.state.queryTecnologie);

    this.setState({ isLoading: true });

    fetch(this.api + 'product/' + this.state.queryItems + this.state.queryTecnologie)
      .then(response => {
        if (response.ok) {


          const totalCount = response.headers.get('x-wp-total');
          const pages = response.headers.get('x-wp-totalpages');


          console.log('totalCount', totalCount);
          console.log('pages', pages);

          // this.setState({ pages: pages })
          if (pages > 1) {
            this.loadMore(totalCount, pages);
          }

          return response.json();
        } else {
          throw new Error('Something went wrong ...');
        }
      }).then(data => {
        console.log("data", data);
        this.setProducts(data);

      });
  }





  loadMore(totalCount, pages) {
    // console.log("loadmore" + totalCount + " " + pages);

    // Loop all pages, which was counted from the first REST API fetch.
    for (let i = 2; i <= pages; i++) {
      fetch(this.api + 'product/' + this.state.queryItems + '&page=' + i)
        .then(response => response.json())
        .then(data => {

          this.setProducts(data);

        });
    }

  }


  setProducts(data) {

    // Add data to contacts array.
    products.push(...data);
    console.log("products", products);

    // return products;
    this.setState({ data: products, isLoading: false })

    //save products in sessionStorage
    sessionStorage.setItem('products_' + this.props.settoreMerceologico + '_' + this.props.applicazioni + '_' + this.props.tecnologie, JSON.stringify(products));

  }




  loadCategorieApplicative() {
    console.log("loadCategorieApplicative");

    let url = "";


    //loadCategorieApplicative per settoreMerceologico
    if (this.props.settoreMerceologico) {
      url = this.apiV2 + 'categorie-applicative?settore_merceologico=' + this.props.settoreMerceologico + '&lang=' + this.lang;

      // get CategorieApplicative from sessionStorage if present otherwise load items
      const sessionStorage_applicazioni_settoreMerceologico = sessionStorage.getItem('applicazioni_settoreMerceologico_' + this.props.settoreMerceologico);
      if (sessionStorage_applicazioni_settoreMerceologico !== null) {
        console.log("sessionStorage_applicazioni_settoreMerceologico", sessionStorage_applicazioni_settoreMerceologico);
        this.setState({ categorieApplicative: JSON.parse(sessionStorage_applicazioni_settoreMerceologico), isLoading: false })
        return;
      }



      fetch(url)
        .then(response => response.json())
        .then(data => {

          console.log('loadCategorieApplicative', data);
          // return products;
          this.setState({ categorieApplicative: data, isLoading: false })

          sessionStorage.setItem('applicazioni_settoreMerceologico_' + this.props.settoreMerceologico, JSON.stringify(data));


        });
    }
    //loadCategorieApplicative per settoreMerceologico

    //loadCategorieApplicative per tecnologie
    if (this.props.tecnologie) {
      url = this.apiV2 + 'categorie-applicative-tecnologie?tecnologie=' + this.props.tecnologie + '&lang=' + this.lang;

      // get CategorieApplicative from sessionStorage if present otherwise load items
      const sessionStorage_applicazioni_tecnologie = sessionStorage.getItem('applicazioni_tecnologie_' + this.props.tecnologie);
      if (sessionStorage_applicazioni_tecnologie !== null) {
        console.log("sessionStorage_applicazioni_tecnologie", sessionStorage_applicazioni_tecnologie);
        this.setState({ categorieApplicative: JSON.parse(sessionStorage_applicazioni_tecnologie), isLoading: false })
        return;
      }


      fetch(url)
        .then(response => response.json())
        .then(data => {

          console.log('loadCategorieApplicative', data);
          // return products;
          this.setState({ categorieApplicative: data, isLoading: false })

          sessionStorage.setItem('applicazioni_tecnologie_' + this.props.tecnologie, JSON.stringify(data));

        });


    }
    //loadCategorieApplicative per tecnologie


    console.log("url", url);





  }


  // getFirstTecnologieProducts(products) {
  //
  //   if (products.length == 0) { return products; }
  //   let firstTecnologieProducts = [];
  //
  //   console.log('getFirstTecnologieProducts',products);
  //
  //   // getFirstTecnologia - create separate function for this! TO-DO
  //   const firstTecnologia = getTaxonomyList(products,'tecnologie').shift().value;
  //   console.log("firstTecnologia",firstTecnologia);
  //   // getFirstTecnologia
  //
  //   // filter by first tecnologie
  //   firstTecnologieProducts = products.filter(item => {
  //     // loop for multiple values in api
  //     for (var i = 0; i < item.tecnologie_names.length; i++) {
  //       if (item.tecnologie_names[i] == firstTecnologia) { return true; }
  //     }
  //   });
  //   // filter by first tecnologie
  //
  //   return firstTecnologieProducts;
  //
  // }



  searchHandler(event) {

    let searchUpdatedList = products;


    
    let searcjQery = event.target.value.toLowerCase();

    searchUpdatedList = searchUpdatedList.filter((el) => {

      let title = el.title.rendered.toLowerCase();
      let codice_prodotto = el.codice_prodotto.toLowerCase();

      return ((title.indexOf(searcjQery) !== -1) || (codice_prodotto.indexOf(searcjQery) !== -1));
    })



    this.setState({ data: searchUpdatedList });


  }


  onSearchFocus(event) {
      console.log("onSearchFocus");
      this.setState({ data: products });

      document.querySelectorAll('input[type=radio]').forEach( el => el.checked = false );

      
  }










  render() {
    //console.log("render app");

    //console.log("isLoading", this.state.isLoading);


    let ProductListItems;
    // if (this.firstLoad) {
    //   ProductListItems = this.getFirstTecnologieProducts(this.state.data);
    // } else {
    //   ProductListItems = this.state.data;
    // }
    ProductListItems = this.state.data;

    
    

    let getTaxonomyList_tecnologie = getTaxonomyList(products, 'tecnologie');
    let getTaxonomyList_brand = getTaxonomyList(products, 'brand');
    let getTaxonomyList_product_tag = getTaxonomyList(products, 'product_tag');



    let taxonomyListCount = getTaxonomyList_tecnologie.length + getTaxonomyList_brand.length + getTaxonomyList_product_tag.length;
    //console.log("taxonomyListCount", taxonomyListCount);

    return (
      <div className="App">

        {(this.props.settoreMerceologico || this.props.tecnologie) &&
          <CategorieApplicative data={this.state.categorieApplicative} selectedApplicazione={this.props.applicazioni} labels={this.props.labels} tecnologie={this.props.tecnologie} />
        }

        {(this.props.applicazioni) &&
          <div className="mt-2">
            {(this.state.isLoading == false) ?
              <div className="row">
                <div className="col-md-3">




                  <div className="mb-4 p-3 border border-primary roundedx" style={{ borderRadius: 15, minHeight: '100px' }}>

                    <input type="text" id="searchProductsInput" className="search mb-4  rounded p-2 w-100" onChange={this.searchHandler} onFocus={ this.onSearchFocus } placeholder="Cerca" />


                   

                    {getTaxonomyList_tecnologie.length > 1 &&
                      <TaxonomyFilter data={getTaxonomyList_tecnologie} updateTextCB={this.updateText1} taxonomy="tecnologie" label={this.SCEGLI_LA_TECNOLOGIA} inputType="radio" />
                    }



                    {/* selectedUpdatedList */}

                    {getTaxonomyList_product_tag.length > 1 &&
                      <TaxonomyFilter data={getTaxonomyList_product_tag} updateTextCB={this.updateText1} taxonomy="product_tag" label={this.FILTRA_TRA} inputType="radio" />
                    }


 {/*
                    {getTaxonomyList_brand.length > 1 &&
                      <TaxonomyFilter data={getTaxonomyList_brand} updateTextCB={this.updateText1} taxonomy="brand" label={this.SCEGLI_IL_BRAND} inputType="radio" />
                    }

*/}

                    {/* {taxonomyListCount <= 3 &&
                      <div className="taxonomy-filter-container">{this.NESSUN_FILTRO_DISPONIBILE}</div>

                    } */}


                  </div>

                </div>

                <div className="col-md-9"><ProductList data={ProductListItems} homeUrl={this.props.home_url} tecnologiaLabel={this.TECNOLOGIA} formatoLabel={this.FORMATO} nessunRisultato={this.NESSUN_RISULTATO} /></div>
              </div>
              : <div className="generon-spinner text-center w-100"><img src={"https://www.generon.it/wp-content/themes/generon-understrap-child/images/Spinner-1s-120px.gif"} /></div>
            }

          </div>
        }



      </div>
    );
  }
}

export default App;
